import { render } from "./SurveyList.vue?vue&type=template&id=bbf989ba"
import script from "./SurveyList.vue?vue&type=script&lang=js"
export * from "./SurveyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__